import { render, staticRenderFns } from "./StoresModal.vue?vue&type=template&id=1b5b2b7c&scoped=true&"
import script from "./StoresModal.vue?vue&type=script&lang=ts&"
export * from "./StoresModal.vue?vue&type=script&lang=ts&"
import style0 from "./StoresModal.vue?vue&type=style&index=0&id=1b5b2b7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b2b7c",
  null
  
)

export default component.exports